import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollSmoother from 'gsap/ScrollSmoother';
import Flip from 'gsap/Flip';

if ('scrollRestoration' in history) {
  // Verhindert die automatische Scroll-Wiederherstellung
  history.scrollRestoration = 'manual';
}

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollSmoother);
gsap.registerPlugin(Flip);

const scrollSmootherInstance = new ScrollSmoother({
  wrapper: '[data-scroll-smoother="wrapper"]',
  content: '[data-scroll-smoother="content"]',
  smooth: 0.8,
  ignoreMobileResize: true,
  smoothTouch: 0.1,
});

export { gsap, ScrollTrigger, ScrollSmoother,  Flip, scrollSmootherInstance };